import React, { useEffect, useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { announcements } from "../data/navigation";
import { ease } from "../utils/styles";
export function AnnouncementBar() {
  const [index, setIndex] = useState(0);
  const reduce = useReducedMotion();
  useEffect(() => {
    if (reduce) return;
    const t = window.setInterval(() => setIndex(i => (i + 1) % announcements.length), 4500);
    return () => window.clearInterval(t);
  }, [reduce]);
  return <div className="flex h-9 items-center justify-center overflow-hidden bg-ink px-4 text-center text-xs text-paper/85" role="region" aria-label="Aankondiging" data-id="element-22" data-mp="5t9egg2f7k22">
      <AnimatePresence mode="wait" initial={false} data-id="element-23" data-mp="3s1semsot5od2">
        <motion.p key={index} initial={{
        opacity: 0,
        y: 6
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -6
      }} transition={{
        duration: 0.2,
        ease
      }} className="truncate" data-id="element-24" data-mp="3s33kcy1td66t">
          {announcements[index]}
        </motion.p>
      </AnimatePresence>
    </div>;
}